module.exports = __webpack_public_path__ + "img/insurance company thumb.3d875d36.png";